module.exports = __webpack_public_path__ + "static/media/main idea.edb0e98f.mp3";